export default "__VITE_ASSET__eb5cd9f4__"